import { createFileRoute } from "@tanstack/react-router";

import { Livesheet } from "~/components/feature/livesheet/Livesheet";

export const Route = createFileRoute("/_app/livesheet")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Livesheet />;
}
